import React from 'react';
import { bool, shape, string } from 'prop-types';

const AdministrativeWorks = ({
  className = 'icon',
  notUseClass = false,
  style = { color: 'currentColor' },
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M15 17H9V11H15V17ZM11 15H13V13H11V15Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M14 3C15.1 3 16 3.9 16 5V7H20C21.1 7 22 7.9 22 9V20C22 21.1 21.1 22 20 22H4C2.9 22 2 21.1 2 20V9C2 7.9 2.9 7 4 7H8V5C8 3.9 8.9 3 10 3H14ZM4 20H20V9H4V20ZM10 7H14V5H10V7Z" fill="currentColor" />
  </svg>
);

AdministrativeWorks.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default AdministrativeWorks;
